<template>
  <div class="stat-refs">
    <div class="scrollMinimal">
      <table>
        <thead>
          <tr>
            <th>SESSION<br>
              <select v-model="filterSession">
                <option value="">Toutes</option>
                <option v-for="s in sessions" :key="s" :value="s">{{ s }}</option>
              </select>
            </th>
            <th class="titre">ACTION<br>
              <select v-model="filterAction">
                <option value="">Toutes</option>
                <option v-for="a in actions" :key="a" :value="a">{{ a }}</option>
              </select>
            </th>
            <th>TAG<br>
              <select v-model="filterTag">
                <option value="">Tous</option>
                <option v-for="t in tags" :key="t" :value="t">{{ t }}</option>
              </select>
            </th>
            <th>VALUE<br>
              <button @click="sortKey = 'value'; sortAsc = !sortAsc">
                {{ sortKey === 'value' ? (sortAsc ? 'A' : 'Z') : '↕' }}
              </button>
            </th>
            <th>LISTE PAR<br>
              <select v-model="sortKey">
                <option value="date">Date</option>
                <option value="action">Action</option>
                <option value="tag">Tag</option>
                <option value="session">Session</option>
              </select>
              <button @click="sortAsc = !sortAsc">{{ sortAsc ? 'A' : 'Z' }}</button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in filteredSorted" :key="row.id">
            <td>{{ row.session }}</td>
            <td>{{ row.action }}</td>
            <td>{{ row.tag }}</td>
            <td>{{ row.value }}</td>
            <td>{{ row.date }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatRefs',
  data() {
    return {
      filterAction: '',
      filterTag: '',
      filterSession: '',
      sortKey: 'date',
      sortAsc: false,
      refsData: []
    };
  },
  mounted() {
    fetch('/Refs/stats.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: 'poelvoorde' })
    })
      .then(res => res.json())
      .then(data => { this.refsData = Array.isArray(data) ? data : []; })
      .catch(() => { this.refsData = []; });
  },
  computed: {
    sessions() {
      const all = [...new Set(this.refsData.map(r => r.session))];
      return all.includes('') ? ['', ...all.filter(s => s !== '')] : all;
    },
    actions() {
      return [...new Set(this.refsData.map(r => r.action))].filter(Boolean);
    },
    tags() {
      return [...new Set(this.refsData.map(r => r.tag))].filter(Boolean);
    },
    filtered() {
      return this.refsData.filter(row =>
        (!this.filterSession || row.session === this.filterSession) &&
        (!this.filterAction || row.action === this.filterAction) &&
        (!this.filterTag || row.tag === this.filterTag)
      );
    },
    filteredSorted() {
      return [...this.filtered].sort((a, b) => {
        let valA = this.sortKey === 'date' ? new Date(a[this.sortKey] || '') : (a[this.sortKey] || '');
        let valB = this.sortKey === 'date' ? new Date(b[this.sortKey] || '') : (b[this.sortKey] || '');
        if (valA < valB) return this.sortAsc ? -1 : 1;
        if (valA > valB) return this.sortAsc ? 1 : -1;
        return 0;
      });
    }
  }
};
</script>

<style scoped>
.stat-refs {
  padding: 10px;
  color: var(--colorLight);
  min-width: 600px;
}
table { width: 100%; border: none; font-size: 12px; text-align: left; }
th, td { padding: 0 10px; }
.titre { padding: 10px; }
thead { background: var(--colorLight); color: var(--colorDark) !important; }
button {
  background: var(--colorDark);
  color: var(--colorLight);
  border: none;
  border-radius: 20px;
  padding: 0.5em 1em;
  cursor: pointer;
}
button:hover { background: var(--colorActive); }
select {
  padding: 6px;
  border: 0;
  border-radius: 20px;
  font-size: 1em;
  background-color: white;
}
</style>
